import React, { Suspense } from "react";
import { ApolloProvider } from "@apollo/client";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import { client } from "config/client";

import LoadingScreen from "./containers/LoadingScreen/LoadingScreen";
import CookiesBanner from "./components/CookiesBanner";
import Footer from "./components/Footer";

import "./stylesheets/app.scss";
import Routes from "Routes";

import { GrowthBookProvider } from "@growthbook/growthbook-react";
import { growthbook } from "utils/growthbook";

import { setInitialHubSpotPagePath, trackSubsequentHubSpotPageView } from "./utils/hubspotTracking"

const history = createBrowserHistory();
history && setInitialHubSpotPagePath(history);

// Listen and notify Segment and Hubspot of client-side page updates
history.listen((location) => {
  window.analytics && window.analytics.page();
  location && trackSubsequentHubSpotPageView(location);
});

function App() {
  return (
    <div id="app">
      <ApolloProvider client={client}>
        <Suspense fallback={<LoadingScreen />}>
          <Router history={history}>
            <GrowthBookProvider growthbook={growthbook}>
              <Routes />
              <Footer />
              <CookiesBanner />
            </GrowthBookProvider>
          </Router>
        </Suspense>
      </ApolloProvider>
    </div>
  );
}

export default App;
